module.exports = __webpack_public_path__ + "static/media/4.ac00fe1a.png";